export const withSecurity = Component => Component;
